import React from 'react';
import s from './s.module.less';

interface CheckboxOptionProps {
    id: string;
    label: string;
    checked: boolean;
    onChange: (id: string, checked: boolean) => void;
    size?: 'default' | 'compact'; // 新增size属性
    width?: {
        pc?: string | number; // PC端宽度
        mobile?: string | number; // 移动端宽度
    };
}

export default function CheckboxOption({ id, label, checked, onChange, size = 'default', width }: CheckboxOptionProps) {
    const handleChange = () => {
        onChange(id, !checked);
    };

    // 生成自定义样式
    const customStyle: React.CSSProperties = {};
    if (width) {
        if (width.pc) {
            (customStyle as any)['--pc-width'] = typeof width.pc === 'number' ? `${width.pc}px` : width.pc;
        }
        if (width.mobile) {
            (customStyle as any)['--mobile-width'] = typeof width.mobile === 'number' ? `${width.mobile}px` : width.mobile;
        }
    }

    return (
        <div
            className={`${s.option} ${checked ? s.selected : ''} ${s[size]}`}
            style={customStyle}
            onClick={handleChange}
            role="checkbox"
            aria-checked={checked}
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    handleChange();
                }
            }}
        >
            <div className={`${s.checkbox} ${checked ? s.checked : ''}`}>
                {checked && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path
                            d="M10 3L4.5 8.5L2 6"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                )}
            </div>
            <span className={s.label}>
                {label}
            </span>
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={() => {}} // 防止重复触发
                className={s.hiddenInput}
                tabIndex={-1}
            />
        </div>
    );
}
